/*
 * @description:
 * @author: Jason Wong
 * @since: 2024-07-11 11:18:41
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import {set} from 'lodash';

Vue.use(VueI18n);

function genMessage(langs, prefix = "lang") {
    const obj = {};

    langs.keys().forEach((key) => {
        const langFileModule = langs(key).default;
        let fileName = key.replace(`./${prefix}/`, "").replace(/^\.\//, "");
        const lastIndex = fileName.lastIndexOf(".");
        fileName = fileName.substring(0, lastIndex);
        const keyList = fileName.split("/");
        const moduleName = keyList.shift();
        const objKey = keyList.join(".");

        if (moduleName) {
            if (objKey) {
                set(obj, moduleName, obj[moduleName] || {});
                set(obj[moduleName], objKey, langFileModule);
            } else {
                set(obj, moduleName, langFileModule || {});
            }
        }
    });

    return obj;
}

export const i18n = new VueI18n({
    locale: "zh-CN",
    messages: {
        "zh-CN": genMessage(require.context("./lang/zh-CN", true, /\.js$/), "zh-CN"),
        en: genMessage(require.context("./lang/en", true, /\.js$/), "en"),
    },
});

export function t(key) {
    return i18n.t(key);
}

export default i18n;